module.exports = __webpack_public_path__ + "img/social-weibo.0d50dc61.svg";